// `/onboarding/{co}/{token}` (ONBOARDING-P1): the client owner's onboarding intake. A public route,
// outside the auth guard like `/survey/`: the token is the key, and the owner has no account yet
// (session-expiry skips `/onboarding/`).
import { createRoute } from "@tanstack/react-router";
import { OnboardingIntakePage } from "../features/onboarding/intake-page";
import { rootRoute } from "./__root";

export const onboardingIntakeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "onboarding/$co/$token",
  component: function OnboardingIntake() {
    const { api } = onboardingIntakeRoute.useRouteContext();
    const { co, token } = onboardingIntakeRoute.useParams();
    return <OnboardingIntakePage api={api} co={co} token={token} />;
  },
});
